import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';

//Services
import { deleteData, getAllDetailsDirect, postAllData } from '../../../service/ProductService';

import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { convertDate, convertMonthFormat, parseDDMMYYYY } from '../../../appconfig/AppHelper';
import { APP_HOSPITAL, APP_STATES, COLLEGES, College_Approval, SINGLE_COLLEGE_APPROVAL, SINGLE_COLLEGE_APPROVAL_DELETE, UNIVERSITY } from '../../../config/ApiConstant';
import { defaultPageRowOptions, defaultRowOptions, degreeList, paginatorLinks, showingEntries, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { AddApprovalMasterValidate } from '../../../config/Validate';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { ApprovalMasterCollegeColumnsList } from '../../../appconfig/DatatableSetting';
import { Column } from 'primereact/column';
import { commonNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { Dialog } from 'primereact/dialog';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

import axiosInstance from '../../../config/axiosInstance';
import { Badge } from 'primereact/badge';

export const AddApprovalMasetr = () => {
    document.title = 'Approval Master | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const navigate = useNavigate();

    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [approvalData, setApprovalData] = useState<any>({});
    const [date, setDate] = useState<any>();
    const [errors, setErrors] = useState<any>({});
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [approveCollegeList, setApproveCollegeList] = useState<any>([]);
    const [approveCollegeDetail, setApproveCollegeDetail] = useState<any>([]);
    const [isDegreeMfarm, setIsDegreeMfarm] = useState<any>(false);

    //state
    const [statesList, setStatesList] = useState<any>([]);

    //college
    const [collegeList, setCollegeList] = useState<any>([]);

    //University
    const [universityList, setUniversityList] = useState<any>([]);

    //Hospital
    const [hospitalList, setHospitalList] = useState<any>([]);

    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>(null);

    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [editId, setEditId] = useState<any>(null);

    // const [fromDates, setFromDates] = useState<string | Date | Date[] | any | null>([new Date()]);

    const [fromDates, setFromDates] = useState({
        start: new Date() as Date | null,
        end: new Date() as Date | null
    });

    // useEffect
    useEffect(() => {
        getStates();
        getAllUniversity();
        getAllHospital();
    }, []);

    useEffect(() => {
        getAllColleges();
    }, [approvalData?.StateNm]);


    
    // Get States
    const getStates = async () => {
        try {
            const response = await getAllDetailsDirect(APP_STATES);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setStatesList([]);
                } else {
                    let stateData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const stateObj: any = {};
                        stateObj['name'] = DataList[i].name;
                        stateObj['code'] = DataList[i].id;
                        stateData.push(stateObj);
                    }
                    setStatesList(stateData);
                }
            } else {
                setStatesList([]);
            }
        } catch (error: any) {
            setStatesList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get Colleges
    const getAllColleges = async () => {
        try {
            let state = !window.cn(approvalData?.StateNm) ? approvalData?.StateNm?.name : '';
            const response = await getAllDetailsDirect(COLLEGES + '?type=all&StateNm=' + state);
            if (response) {
                const DataList: any = response?.data;
                if (DataList.length === 0) {
                    setCollegeList([]);
                } else {
                    let collegaData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const collegeObj: any = {};
                        collegeObj['name'] = DataList[i].orgnameeng;
                        collegeObj['code'] = DataList[i].orgcode;
                        collegaData.push(collegeObj);
                    }
                    setCollegeList(collegaData);
                }
            } else {
                setCollegeList([]);
            }
        } catch (error: any) {
            setCollegeList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get University
    const getAllUniversity = async () => {
        try {
            const response = await getAllDetailsDirect(UNIVERSITY + '?type=all');
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setUniversityList([]);
                } else {
                    let universityData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const universityObj: any = {};
                        universityObj['name'] = DataList[i].UName;
                        universityObj['code'] = DataList[i].SrNo;
                        universityData.push(universityObj);
                    }
                    setUniversityList(universityData);
                }
            } else {
                setUniversityList([]);
            }
        } catch (error: any) {
            setUniversityList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get Hospital
    const getAllHospital = async () => {
        try {
            const response = await getAllDetailsDirect(APP_HOSPITAL + '?type=all');
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setHospitalList([]);
                } else {
                    let hospitalData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const hospitalObj: any = {};
                        hospitalObj['name'] = DataList[i].HospName;
                        hospitalObj['code'] = DataList[i].HospNo;
                        hospitalData.push(hospitalObj);
                    }
                    setHospitalList(hospitalData);
                }
            } else {
                setHospitalList([]);
            }
        } catch (error: any) {
            setHospitalList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    const onFromDateChange = (start: any, end: any) => {
        setFromDates({ start, end });
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'StateNm' || name === 'university' || name === 'degree' || name === 'hospital') {
            val = e;
        } else if (name === 'college') {
            val = e;
            if (!isEdit) {
                getApprovalList(e);
            }
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        if (name === 'degree') {
            setIsDegreeMfarm(val?.name === 'M Pharm');
        }
        setApprovalData({ ...approvalData, [name]: val });
    };

    // handle change date
    const handleChangeDate = (val: any) => {
        setDate(val);
    };

    const getApprovalList = async (selectedCollege: any) => {
        try {
            setPageLoad(false);
            const response = await getAllDetailsDirect(SINGLE_COLLEGE_APPROVAL + '?orgcode=' + selectedCollege?.code);

            if (response) {
                setApproveCollegeList(response?.data?.list);
                setApproveCollegeDetail(response?.data?.details);
                setPageLoad(true);
            }
        } catch (error: any) {
            if (error.response) {
                setApproveCollegeList([]);
                setPageLoad(true);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    const onEditClick = (rowData: any) => {
        setIsEdit(true);
        setEditId(rowData.id);

        const selectedUniversity = universityList.find(
            (u: any) => u.code === rowData.USrNo
        );

        const selectedHospital =
            Number(rowData.HospNo2) > 0
                ? hospitalList.find((h: any) => h.code === Number(rowData.HospNo2))
                : null;

        setApprovalData({
            StateNm: { name: rowData.StateNm, code: rowData.StateSrNo },
            college: { name: rowData.orgNm, code: rowData.orgcode },
            university: selectedUniversity || null,
            degree: { name: rowData.DegNm, code: rowData.degree },
            subject: rowData.subject,
            pciResNo: rowData.pciresno,
            pciRefNo: rowData.pcirefno,
            seatsTotal: rowData.Seat,
            qualdateorg: rowData.qualdateorg,
            qualdateorgf: rowData.qualdateorgf,
            hospital: selectedHospital
        });
        setIsDegreeMfarm(rowData.DegNm === 'M Pharm');

        setDate(parseDDMMYYYY(rowData.pcicirdt));
       

        setFromDates({
            start: new Date(rowData.validyear, rowData.validmonth - 1),
            end: new Date(rowData.validyearf, rowData.validmonthf, 0)
        });

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    };


    // On submit
    const onSubmit = async () => {
        try {
            const { errors, isError } = AddApprovalMasterValidate(approvalData, isDegreeMfarm);
            setErrors(errors);
            

            if (isError) return;

            setSubmitLoading(true);

            const pciCircularDateConvert = convertDate(date);
            const approvalYearFromCon = convertMonthFormat(fromDates?.start);
            const approvalYearToCon = convertMonthFormat(fromDates?.end);

            const fromDateApproval = new Date(fromDates?.start || new Date());
            const validMonthF = fromDateApproval.getMonth() + 1;
            const validYearF = fromDateApproval.getFullYear();

            const toDateApproval = new Date(fromDates?.end || new Date());
            const validMonth = toDateApproval.getMonth() + 1;
            const validYear = toDateApproval.getFullYear();

            // payload
            const requestData: any = {
                StateNm: approvalData?.StateNm?.name,
                StateSrNo: approvalData?.StateNm?.code,
                orgNm: approvalData?.college?.name,
                orgcode: approvalData?.college?.code,
                DegNm: approvalData?.degree?.name,
                degree: approvalData?.degree?.code,
                subject: approvalData?.subject,
                university: approvalData?.university?.name,
                USrno: approvalData?.university?.code,

                examautho: approvalData?.university?.name,
                examauthoSrNo: approvalData?.university?.code,

                Seat: approvalData?.seatsTotal,
                pcirefno: approvalData?.pciRefNo,
                pciresno: approvalData?.pciResNo,
                HospNo1: approvalData?.hospital?.name,
                HospNo2: approvalData?.hospital?.code,

                pcicirdt: pciCircularDateConvert,
                qualdateorg: approvalYearFromCon,
                qualdateorgf: approvalYearToCon,

                validmonth: validMonthF,
                validyear: validYearF,
                validmonthf: validMonth,
                validyearf: validYear
            };

            if (!isDegreeMfarm) {
                delete requestData.subject;
            }

            // edit id
            if (isEdit && editId) {
                requestData.id = editId;
            }

            let response;
            if (isEdit && editId) {
                response = await axiosInstance.post(
                    College_Approval,
                    requestData
                );
            } else {
                response = await postAllData(College_Approval, requestData);
            }

            if (response) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: isEdit ? response?.data?.data : response?.data
                });

                setTimeout(() => {
                    navigate('/app/approval');
                }, 2000);
            }
        } catch {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
        } finally {
            setSubmitLoading(false);
        }
    };



    // Template for action body
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions">
                    <Button
                        icon="pi pi-pencil"
                        tooltip="Edit"
                        className="p-button-warning p-button-rounded ml-2"
                        onClick={() => onEditClick(rowData)}
                    />
                    <Button icon="pi pi-trash" tooltip="Delete" tooltipOptions={{ position: 'top' }} className="p-button-danger p-button-rounded ml-2" onClick={() => openDeleteModal(rowData?.id)} />
                </div>
            </>
        );
    };

    // Open delete modal
    const openDeleteModal = (id: any) => {
        setDeleteId(id);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setSubmitLoading(false);
        setDeleteModal(false);
    };

    // Delete college api call
    const deleteCollegeApiCall = async () => {
        try {
            setSubmitLoading(true);
            // Delete api call
            const response = await axiosInstance.post(SINGLE_COLLEGE_APPROVAL_DELETE + '?id=' + deleteId);
            if (response) {

                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.data?.message
                });
                setSubmitLoading(false);
                setDeleteModal(false);
                setDeleteId(null);
                getApprovalList(approvalData?.college);
                setPageLoad(true);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setSubmitLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setSubmitLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Master'} pageName={'Add Approval Master'} pageTitle={'Add Approval Master'} goToPage={true} />

            <div className="card">
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-4">
                        <label htmlFor="StateNm">
                            State <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={approvalData?.StateNm}
                                name="StateNm"
                                options={statesList}
                                filter
                                optionLabel="name"
                                placeholder="Select State"
                                onChange={(e) => onInputChange(e.value, 'StateNm')}
                                className={errors['StateNm'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['StateNm']}</small>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="college">
                            College <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={approvalData?.college}
                                name="college"
                                options={collegeList}
                                filter
                                optionLabel="name"
                                placeholder="Select College"
                                onChange={(e) => onInputChange(e.value, 'college')}
                                className={errors['college'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['college']}</small>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="university">
                            University <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={approvalData?.university}
                                name="university"
                                options={universityList}
                                filter
                                optionLabel="name"
                                placeholder="Select University"
                                onChange={(e) => onInputChange(e.value, 'university')}
                                className={errors['university'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['university']}</small>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="degree">
                            Degree <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={approvalData?.degree}
                                name="degree"
                                options={degreeList}
                                filter
                                optionLabel="name"
                                placeholder="Select Degree"
                                onChange={(e) => onInputChange(e.value, 'degree')}
                                className={errors['degree'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['degree']}</small>
                    </div>

                    {isDegreeMfarm && (
                        <div className="field col-12 md:col-4">
                            <label>
                                Subject <span style={{ color: 'red' }}>*</span>
                            </label>

                            <InputText
                                value={approvalData?.subject}
                                name="subject"
                                placeholder="Enter subject"
                                onChange={(e) => onInputChange(e, 'subject')}
                                className={errors['subject'] && 'p-invalid'}
                            />

                            <small className="p-invalid-txt">{errors['subject']}</small>
                        </div>
                    )}


                    <div className="field col-12 md:col-4">
                        <label htmlFor="PCI Res No">
                            PCI Res No <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputText value={approvalData?.pciResNo} name="pciResNo" autoComplete="off" placeholder="Enter PCI Res No" onChange={(e) => onInputChange(e, 'pciResNo')} className={errors['pciResNo'] && 'p-invalid'} />
                            <span className="focus-bg"></span>
                        </div>

                        <small className="p-invalid-txt">{errors['pciResNo']}</small>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="PCI Ref No">
                            PCI Ref No <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputText value={approvalData?.pciRefNo} name="pciRefNo" autoComplete="off" placeholder="Enter PCI Ref No" onChange={(e) => onInputChange(e, 'pciRefNo')} className={errors['pciRefNo'] && 'p-invalid'} />
                            <span className="focus-bg"></span>
                        </div>

                        <small className="p-invalid-txt">{errors['pciRefNo']}</small>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="date">PCI Circular Date</label>
                        <div className="input-effect-div">
                            <Calendar
                                value={date}
                                dateFormat="dd-M-yy"
                                onChange={(e: any) => {
                                    handleChangeDate(e.value);
                                }}
                                showIcon
                            />
                        </div>
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="seat">Seat</label>
                        <div className="input-effect-div">
                            <InputText value={approvalData?.seatsTotal} name="seatsTotal" autoComplete="off" type='number' placeholder="Enter Seat" onChange={(e) => onInputChange(e, 'seatsTotal')} className={errors['seatsTotal'] && 'p-invalid'} />
                            <span className="focus-bg"></span>
                            <small className="p-invalid-txt">{errors['seatsTotal']}</small>
                        </div>
                    </div>


                    <div className="field col-12 md:col-4">
                        <label htmlFor="date">From and To Date</label>
                        <div className="input-effect-div">
                            <CustomDatePicker startDate={fromDates?.start} endDate={fromDates?.end} onChange={onFromDateChange} />
                        </div>
                    </div>

                    <div className="field col-12 md:col-4">
                        <label htmlFor="hospital">Approved Hospital</label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={approvalData?.hospital}
                                name="hospital"
                                options={hospitalList}
                                filter
                                optionLabel="name"
                                placeholder="Select Hospital"
                                onChange={(e) => onInputChange(e.value, 'hospital')}
                                className={errors['hospital'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                    </div>

                    {!window.cn(approveCollegeDetail) && (

                        <div className="field col-12 md:col-4">
                            <label><b>PCI Code:</b> </label>
                            <div>
                                <Badge className='py-1' value={!window.cn(approveCollegeDetail?.pci_code) ? approveCollegeDetail?.pci_code : ""}></Badge>
                            </div>
                        </div>
                    )}
                </div>

                <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                        <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                            <Button
                                label={isEdit ? 'Update' : 'Submit'}
                                icon="pi pi-check"
                                onClick={onSubmit}
                                loading={submitLoading}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid crud-demo mt-3">
                <div className="col-12">
                    <div className="card">
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={approveCollegeList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    rows={defaultRowOptions}
                                    paginator={approveCollegeList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    removableSort
                                >
                                    {ApprovalMasterCollegeColumnsList.map((col, i) => {
                                        if (col.field === 'qualdateorg') {
                                            return <Column key={col.field} field={col.field} header={col.header} style={{ minWidth: '6rem' }} />;
                                        } else if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'qualdateorgf') {
                                            return <Column key={col.field} field={col.field} header={col.header} style={{ minWidth: '6rem' }} />;
                                        } else if (col.field === 'date') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'orgNm') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commonNameTemplate} filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'university') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'DegNm') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {ApprovalMasterCollegeColumnsList.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete College"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteCollegeApiCall} loading={submitLoading} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this College, This will be deleted permanently.</span>
                </div>
            </Dialog>
        </>
    );
};
